import type { AdCampaignRow } from '@/api/advertisingOverview'

const UNNAMED_CAMPAIGN = 'Campaign no longer in Meta'

/** A campaign's name, or what it is when Meta's hierarchy no longer holds it — never a blank. */
export function campaignName(row: Pick<AdCampaignRow, 'name'>): string {
  return row.name ?? UNNAMED_CAMPAIGN
}
